//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams, toCopy} from '@/utils/util.js'
import bottom from '@/assets/img/bottom.png'
import {uploadFile} from '@/utils/auth'
import footerNav from '@/components/footerNav'
import homeTip from '@/components/homeTip'
import {Dialog, Toast} from 'vant';

export default {
  name: "qualityOrderDetail",
  components: {
    footerNav,
    homeTip
  },
  computed: {
    okPercent(){
      if(this.basicForm.spotCheckTotalNum&&this.basicForm.goodTotalNum){
        return ((this.basicForm.goodTotalNum/this.basicForm.spotCheckTotalNum)*100).toFixed(2)
      }else{
        return 0
      }
    }
  },
  data() {
    return {
      number: '',
      popType: 1,
      rowNow:0,
      bottom,
      showPicker1:false,
      showPopup:false,
      loading:false,
      loading1: false,
      loading2: false,
      loading3: false,
      reasonList:[],
      qualityOrderDetailLis:[],
      type:'',
      typeValue:'',
      value: '',
      toCopy,
      reason:'',
      badNumber:'',
      columns1: [{text: '严重', value: 1}, {text: '一般', value: 0}],
      columns: [{text: '是', value: 1}, {text: '否', value: 0}],
      fileList: [],
      showPicker: false,
      basicForm: {
        qualityOrderSn: '',
        sendOrderSn: '',
        purchaseOrderSn: '',
        supplierName: '',
        channelStr: '',
        qualityOrderTypeName: '',
        qualityOrderDetailList: [],
        qualityOrderResultDetailList: [],
        isStockIn: '',
        confirmFileStr: '',
        confirmFile: '',
        remark: '',
        qualityResult: '',
        qualityOrderStatusName: '',
        billDate: '',
        attachedFile: [],
        spotCheckTotalNum:'',
        goodTotalNum:'',
        normalTotalNum:'',
        badTotalNum:'',
        sendTotalGoodsNum:0,
        rejectNum:'',
        colorList:[],
        qualityResultId:'',
        deliveryName:'',
        realitySupplierName:'',
        qualityType:'',
      },
      qualityOrderId: '',
      qualityResultId: '',
      isSend: false,
      canSubmit: true,
      dataList: []
    }
  },
  created() {
  },
  mounted() {
    if (this.$route.query.data) {
      this.dataList = JSON.parse(this.$route.query.data)
    }
    if (this.$route.query.qualityOrderId) {
      this.qualityOrderId = this.$route.query.qualityOrderId
      this.qualityResultId = this.$route.query.qualityResultId
    }
    this.getSpecList()
  },
  methods: {
    hasBtn(id) {
      return this.$store.state.btnList.indexOf(id) != -1
    },
    getSpecList() {
      var queryParams = {
        qualityOrderColorList:this.dataList
      };
      if (this.$route.query.data) {
        queryParams.qualityOrderColorList = this.dataList
      }else{
        queryParams.qualityOrderId = this.qualityOrderId
        queryParams.qualityResultId = this.qualityResultId
        queryParams.qualityOrderColorList = []
      }
      axiosApi.queryQualityOrderByColor(queryParams).then(response => {
        var data = response.content;
        if (data.qualityOrderDetailList) {
          data.qualityOrderDetailList.forEach((item) => {
            item.isEdit = true
          })
        }
        for (var ind in data) {
          var val = data[ind] != null ? data[ind] : ""
          this.$set(this.basicForm, ind, val)
        }
        var channelStr = '';
        if (this.basicForm.firstDeptName) {
          channelStr += this.basicForm.firstDeptName
        }
        if (this.basicForm.secondDeptName) {
          channelStr += '/' + this.basicForm.secondDeptName
        }
        if (data.attachedFile && data.attachedFile.length > 0) {
          data.attachedFile.forEach((item) => {
            this.fileList.push({url: item})
          })
        }
        if (this.basicForm.qualityResult === 0) {
          this.value = '否'
        }
        if (this.basicForm.qualityResult === 1) {
          this.value = '是'
        }
        this.$set(this.basicForm, 'channelStr', channelStr)
        // this.$refs.commonTableRef2.reloadDone()
      }).catch(error => {
        // this.$refs.commonTableRef2.reloadDone()
      })
    },
    toMore() {
      this.$router.push({name: 'qualityOrderDetailMore'})
    },
    toAddReason() {
      this.popType = 1;
      this.number= '';
      this.type = '一般';
      this.typeValue = 0;
      this.reason = '';
      this.showPopup = true
      // this.$router.push({name: 'addReason', type: 2})
    },
    afterRead(file) {
      Toast.loading({
        message: '上传中...',
        forbidClick: true,
        duration:0
      });
      this.canSubmit = false
      // console.log(file)
      // console.log(this.fileList)
      if (Array.isArray(file)) {
        for (var i in file) {
          uploadFile(file[i].file, 'file', url => {
            // this.basicForm.confirmFileStr = url.slice(url.lastIndexOf('/'))
            this.basicForm.attachedFile.push(url)
            if (i == (file.length - 1)) {
              this.canSubmit = true
              Toast.clear()
            }
          });
        }
      } else {
        uploadFile(file.file, 'file', url => {
          // this.basicForm.confirmFileStr = url.slice(url.lastIndexOf('/'))
          this.basicForm.attachedFile.push(url)
          this.canSubmit = true
          Toast.clear()
        });
      }
    },
    delImg(file, detail) {
      return new Promise((resolve, reject) => {
        this.basicForm.attachedFile.splice(detail.index, 1)
        resolve();
      });
    },
    totalChange(){
      var queryParams = {
        ...this.basicForm
      }
      axiosApi.updateQualityNum(queryParams).then(response => {
        var queryParams1 = {
          qualityOrderColorList: this.dataList
        };
        queryQualityOrderByColor(queryParams1).then(response => {
          var data = response.content;
          if (data.qualityOrderDetailList) {
            data.qualityOrderDetailList.forEach((item) => {
              item.isEdit = true
            })
          }
          this.basicForm.qualityOrderDetailList = data.qualityOrderDetailList
          var num = this.basicForm.spotCheckTotalNum
          if(this.basicForm.normalTotalNum){
            num-=parseInt(this.basicForm.normalTotalNum)
          }
          if(this.basicForm.badTotalNum){
            num-=parseInt(this.basicForm.badTotalNum)
          }
          this.basicForm.goodTotalNum=num
        }).catch(error => {
        })
      }).catch(error => {
      })
    },
    //
    chooseConfirm(){
      if(this.popType==1){
        this.basicForm.qualityOrderResultDetailList.push({'remark':this.reason,'num':this.badNumber,'noPassType':this.typeValue,'noPassTypeStr':this.type})
      }else{
        this.basicForm.qualityOrderResultDetailList[this.rowNow]={'remark':this.reason,'num':this.badNumber,'noPassType':this.typeValue,'noPassTypeStr':this.type}
      }
      this.showPopup = false
    },
    deleteRow(i){
      this.basicForm.qualityOrderResultDetailList.splice(i,1)
    },
    onConfirm(value) {
      this.value = value.text;
      this.basicForm.qualityResult = value.value;
      this.showPicker = false;
    },
    open() {
      // if (this.basicForm.qualityOrderStatus != 0) return
      this.showPicker = true
    },
    onClose(){
      this.reason = '';
      this.badNumber = '';
      this.type = '';
    },
    onConfirm1(value){
      this.type = value.text;
      this.typeValue = value.value;
      this.showPicker1 = false;
    },
    checkNum(){
      var num1 = this.basicForm.normalTotalNum||0;
      var num2 = this.basicForm.badTotalNum||0;
      var num3 = 0;
      var num4 = 0;
      for(var i = 0;i<this.basicForm.qualityOrderResultDetailList.length;i++){
        if (this.basicForm.qualityOrderResultDetailList[i].noPassType=='0') {
          num3 += parseInt(this.basicForm.qualityOrderResultDetailList[i].num)
        }
        if (this.basicForm.qualityOrderResultDetailList[i].noPassType=='1') {
          num4 += parseInt(this.basicForm.qualityOrderResultDetailList[i].num)
        }
        // if(this.basicForm.qualityOrderResultDetailList[i].qualityResult!==0&&this.basicForm.qualityOrderResultDetailList[i].qualityResult!==1){
        //   this.$message.error('列表中是否合格不能为空')
        //   return false
        // }
      }
      // this.basicForm.qualityOrderResultDetailList.forEach((item)=>{
      //
      // })
      console.log(num1,num3)
      if (num1!=num3 ) {
        Toast.fail('一般不合格数不对应')
        return false
      }
      if (num2!=num4 ) {
        Toast.fail('严重不合格数不对应')
        return false
      }
      return true
    },
    getGood(){
      var num = this.basicForm.spotCheckTotalNum
      if(this.basicForm.normalTotalNum){
        num-=parseInt(this.basicForm.normalTotalNum)
      }
      if(this.basicForm.badTotalNum){
        num-=parseInt(this.basicForm.badTotalNum)
      }
      console.log(num)
      this.basicForm.goodTotalNum=num
      if(this.okPercent>=90){
        this.basicForm.qualityResult=1
        this.value = '是'
      }else{
        this.basicForm.qualityResult=0
        this.value = '否'
      }
      // if(this.basicForm.qualityOrderResultDetailList.filter((item)=>{return item.noPassType===0}).length==0&&parseInt(this.basicForm.normalTotalNum)>0){
      //   this.basicForm.qualityOrderResultDetailList.push({'reasonId': [], 'remark': '', 'num': this.basicForm.normalTotalNum, 'noPassType': 0,'colorCode':'','qualityResult':''})
      // }
      // if(this.basicForm.qualityOrderResultDetailList.filter((item)=>{return item.noPassType===1}).length==0&&parseInt(this.basicForm.badTotalNum)>0){
      //   this.basicForm.qualityOrderResultDetailList.push({'reasonId': [], 'remark': '', 'num': this.basicForm.badTotalNum, 'noPassType': 1,'colorCode':'','qualityResult':''})
      // }
    },
    save(type) {
      if(!this.canSubmit) return
      if(this.isSend)return
      this.isSend = true
      if(type==1){
        if(!this.checkNum()){
          this.isSend = false
          return
        }
        if(this.basicForm.qualityResult.toString()==""){
          Toast.fail('请选择是否合格');
          this.isSend = false
          return;
        }
        var num = 0
        var num1 = 0
        if(this.basicForm.goodTotalNum){
          num+=parseInt(this.basicForm.goodTotalNum)
        }
        if(this.basicForm.normalTotalNum){
          num+=parseInt(this.basicForm.normalTotalNum)
        }
        if(this.basicForm.badTotalNum){
          num+=parseInt(this.basicForm.badTotalNum)
        }
        if(this.basicForm.spotCheckTotalNum){
          num1 = parseInt(this.basicForm.spotCheckTotalNum)
        }
        if(num>num1){
          Toast.fail('合格数加不合格数不能大于抽检数');
          this.isSend = false
          return
        }
        var queryParams = {
          ...this.basicForm,
          qualityOrderStatus: type,
        }
        axiosApi.submitQualityOrder(queryParams).then(response => {
          this.basicForm.qualityResultId = response.content.qualityResultId
          this.isSend = false
          Toast.success('操作成功');
          if (type != 0) {
            this.$router.back(-1)
          }
        }).catch(error => {
          this.isSend = false
        })
      }
    },
    save1() {
      if (this.loading2) return
      this.loading2 = true
      // if (!this.checkNum()) {
      //   this.$message.error('添加不合格原因的件数与质检结果的不合格件数不对应');
      //   return
      // }
      // for (var i = 0; i < this.basicForm.qualityOrderDetailList.length; i++) {
      //   var num = 0
      //   if (this.basicForm.qualityOrderDetailList[i].goodNum) {
      //     num += parseInt(this.basicForm.qualityOrderDetailList[i].goodNum)
      //   }
      //   if (this.basicForm.qualityOrderDetailList[i].badNum) {
      //     num += parseInt(this.basicForm.qualityOrderDetailList[i].badNum)
      //   }
      //   if (num > parseInt(this.basicForm.qualityOrderDetailList[i].sendGoodsNum)) {
      //     this.$message.error('合格数加不合格数不能大于抽检数');
      //     return
      //   }
      // }
      var queryParams = {
        ...this.basicForm,
      }
      axiosApi.updateQualityOrder(queryParams).then(response => {
        Toast.success('操作成功');
        this.loading2 = false
        this.$router.back(-1)
      }).catch(error => {
        this.loading2 = false
      })
    },
    editRow(item,i){
      this.rowNow = i;
      this.popType = 2;
      this.reason=item.remark;
      this.badNumber=item.num;
      this.typeValue=item.noPassType;
      this.type=item.noPassType==1?'严重':'一般'
      this.showPopup = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/qualityOrder/qualityWrite.vue